import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a3a4f64c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "settings_button" };
const _hoisted_2 = {
    key: 0,
    class: "settings setting_menu"
};
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import ThemeSwitch from '@/materials/molecules/ThemeSwitch.vue';
import { useStore } from '@/store/store';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const store = useStore();
        const isShowMenu = ref(false);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "outer",
                onMouseover: _cache[0] || (_cache[0] = ($event) => (isShowMenu.value = true)),
                onMouseleave: _cache[1] || (_cache[1] = ($event) => (isShowMenu.value = false))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(MaterialIcon, { name: "settings" })
                ]),
                (!_unref(store).state.isSmartPhone && isShowMenu.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(ThemeSwitch)
                    ]))
                    : _createCommentVNode("", true)
            ], 32));
        };
    }
});
